export default __webpack_public_path__ + "static/media/pepe.31c12718.png";